<template>

    <footer class="footer">

        <div class="footer__container">

            <div class="footer__bloc-links">

                <div class="footer__paragraph">

                    <h3 class="footer__paragraph__title">{{ $t('new_footer_links_title') }}</h3>

                    <a :href="makeHref('/login/email')" class="footer__paragraph__link" target="_blank">{{ $t('new_footer_signup') }}</a>
                    <a :href="makeHref('/magic-request-email')" class="footer__paragraph__link" target="_blank">{{ $t('new_footer_already_used') }}</a>
                    <a :href="makeHref('/my-data')" class="footer__paragraph__link" target="_blank">{{ $t('new_footer_data_use') }}</a>
                    <a class="footer__paragraph__link" href="https://app.adjust.com/uez2im" target="_blank">{{ $t('new_footer_android') }}</a>
                    <a class="footer__paragraph__link" href="https://app.adjust.com/uez2im" target="_blank">{{$t('new_footer_iOS') }}</a>
                    <a :href="makeHref('/cookies-policy')" class="footer__paragraph__link" target="_blank">{{ $t('new_footer_cookies_policy') }}</a>
                    <a class="footer__paragraph__link" target="_blank" @click="openModalCookies">{{ $t('new_footer_settings_cookies') }}</a>

                </div>

                <div class="footer__paragraph">

                    <h3 class="footer__paragraph__title">{{ $t('new_footer_title_company') }}</h3>

                    <a :href="makeHref('/foxintelligence')" class="footer__paragraph__link" target="_blank">{{ $t('new_footer_about_us') }}</a>
                    <a :href="makeHref('/press')" class="footer__paragraph__link" target="_blank">{{ $t('new_footer_press_kit') }}</a>
                    <a class="footer__paragraph__link" href="https://www.welcometothejungle.com/en/companies/foxintelligence" target="_blank">{{ $t('new_footer_jobs') }}</a>

                </div>

                <div class="footer__paragraph">

<!--                    <h3 class="footer__paragraph__title">{{ $t('new_footer_blog_title') }}</h3>-->

<!--                    <a v-if="isFrench" class="footer__paragraph__link" href="https://cleanfox.io/blog/actualite-fr/" target="_blank">{{ $t('new_footer_news') }}</a>-->
<!--                    <a v-else class="footer__paragraph__link" href="https://cleanfox.io/blog/cleanfox-news-en/" target="_blank">{{ $t('new_footer_news') }}</a>-->

<!--                    <a v-if="isFrench" class="footer__paragraph__link" href="https://cleanfox.io/blog/pollution-numerique-fr/" target="_blank">{{ $t('new_footer_pollution') }}</a>-->
<!--                    <a v-else class="footer__paragraph__link" href="https://cleanfox.io/blog/digital-pollution-en/" target="_blank">{{ $t('new_footer_pollution') }}</a>-->

<!--                    <a v-if="isFrench" class="footer__paragraph__link" href="https://cleanfox.io/blog/astuces-fr/" target="_blank">{{ $t('new_footer_tips') }}</a>-->
<!--                    <a v-else class="footer__paragraph__link" href="https://cleanfox.io/blog/tips-en/" target="_blank">{{ $t('new_footer_tips') }}</a>-->

                </div>

                <div class="footer__paragraph">

                    <h3 class="footer__paragraph__title">{{ $t('new_footer_help_contact_title') }}</h3>

                    <a :href="makeHref('/faq')" class="footer__paragraph__link" target="_blank">{{ $t('new_footer_FAQ') }}</a>
                    <a class="footer__paragraph__link" href="mailto:support@cleanfox.io" target="_blank">{{ $t('new_footer_contact_us') }}</a>

                </div>

            </div>

            <div class="footer__bloc-switch">

                <lang-switch :green="true"></lang-switch>

                <div v-if="$mq === 'lg'" class="footer__bloc-media">
                    <a class="footer__bloc-media__round" href="https://www.facebook.com/cleanfox/" target="_blank">
                        <img alt="facebook icon" class="footer__bloc-media__img" src="/img/icons/fg-facebook.svg">
                    </a>
                    <a class="footer__bloc-media__round" href="https://twitter.com/cleanfoxapp" target="_blank">
                        <img alt="twitter icon" class="footer__bloc-media__img" src="/img/icons/fg-twitter.svg">
                    </a>
                    <a class="footer__bloc-media__round" href="https://www.instagram.com/cleanfox_/" target="_blank">
                        <img alt="instagram icon" class="footer__bloc-media__img" src="/img/icons/fg-instagram.svg">
                    </a>
                    <a class="footer__bloc-media__round" href="https://www.linkedin.com/company/cleanfox/" target="_blank">
                        <img alt="linked icon" class="footer__bloc-media__img" src="/img/icons/fg-linked-in.svg">
                    </a>
                    <a class="footer__bloc-media__round" href="https://www.youtube.com/channel/UCOTdz6q20jj8rWSiRLFohmw" target="_blank">
                        <img alt="youtube icon" class="footer__bloc-media__img" src="/img/icons/fg-youtube.svg">
                    </a>
                </div>

            </div>

            <div class="footer__dashline"></div>

            <div class="footer__privacy-bloc">

                <div v-if="$mq === 'lg'">

                    <p class="footer__bloc-fox__text">{{ $t('new_footer_copyright') }}</p>

                </div>

                <div class="footer__privacy-bloc__rigth-side">

                    <a :href="makeHref('/impressum')" class="footer__paragraph__link desktop-no-mt" target="_blank">{{ $t('new_footer_impressum') }}</a>

                    <a :href="makeHref('/terms')" class="footer__paragraph__link footer__paragraph__link-middle" target="_blank">{{ $t('new_footer_terms_conditions') }}</a>

                    <a :href="makeHref('/privacy')" class="footer__paragraph__link desktop-no-mt" target="_blank">{{ $t('new_footer_privacy_policy') }}</a>

                </div>

            </div>

            <div v-if="$mq !== 'lg'" class="footer__bloc-media">
                <a class="footer__bloc-media__round" href="https://www.facebook.com/cleanfox/" target="_blank">
                    <img alt="facebook icon" class="footer__bloc-media__img" src="/img/icons/fg-facebook.svg">
                </a>
                <a class="footer__bloc-media__round" href="https://twitter.com/cleanfoxapp" target="_blank">
                    <img alt="twitter icon" class="footer__bloc-media__img" src="/img/icons/fg-twitter.svg">
                </a>
                <a class="footer__bloc-media__round" href="https://www.instagram.com/cleanfox_/" target="_blank">
                    <img alt="instagram icon" class="footer__bloc-media__img" src="/img/icons/fg-instagram.svg">
                </a>
                <a class="footer__bloc-media__round" href="https://www.linkedin.com/company/cleanfox/" target="_blank">
                    <img alt="linked icon" class="footer__bloc-media__img" src="/img/icons/fg-linked-in.svg">
                </a>
                <a class="footer__bloc-media__round" href="https://www.youtube.com/channel/UCOTdz6q20jj8rWSiRLFohmw" target="_blank">
                    <img alt="youtube icon" class="footer__bloc-media__img" src="/img/icons/fg-youtube.svg">
                </a>
            </div>

            <div class="footer__bloc-logo">

                <img alt="logo" class="footer__bloc-logo__img" src="/img/logo/large/sand.svg">

            </div>

            <div v-if="$mq !== 'lg'" class="footer__bloc-fox">

                <p class="footer__bloc-fox__text">{{ $t('new_footer_copyright') }}</p>

            </div>

        </div>

        <modal-cookies-policy ref="mcp"></modal-cookies-policy>

    </footer>

</template>

<script>

import I18n from '@/modules/i18n'

import LangSwitch from '@/components/LangSwitch'
import ModalCookiesPolicy from '@/components/modal/ModalCookiesPolicy'

export default {

    name: 'footer-green',

    components: {LangSwitch, ModalCookiesPolicy},

    computed: {

        isDeutsch() {
            return I18n.get(this) === 'de'
        },

        isFrench() {
            return I18n.get(this) === 'fr'
        }
    },

    data() {
        return {
            year: new Date().getFullYear()
        }
    },

    methods: {

        makeHref(url) {
            return `/${I18n.get(this)}${url}`
        },

        openModalCookies() {

            this.$refs.mcp.open()
        }
    }

}

</script>

<style lang="scss" scoped>

.footer {
    padding: 8px 16px 32px;
    background-color: $rifle;
    display: flex;
    flex-direction: column;
    color: $sand;
    @media screen and (min-width: $above-tablet-length) {
        width: 100%;
        align-items: center;
        padding-top: 40px;
    }

    &__container {
        @media screen and (min-width: $above-tablet-length) {
            width: 100%;
            max-width: 860px;
            margin: 0 32px;
        }
    }

    &__bloc-links {
        @media screen and (min-width: $above-tablet-length) {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
        }
    }

    &__paragraph {
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        &__title {
            font-size: 17px;
            font-weight: bold;
            line-height: 1.3;
            margin-top: 24px;
        }

        &__link {
            font-size: 14px;
            line-height: 1.43;
            margin-top: 8px;
            color: $sand;
        }

        &__link-middle {
            @media screen and (min-width: $above-tablet-length) {
                margin: 0 16px;
            }
        }
    }

    &__bloc-switch {
        margin-top: 32px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }

    &__dashline {
        margin-top: 32px;
        width: 100%;
        height: 1px;
        opacity: 0.16;
        border-radius: 8px;
        background-color: $white;
        @media screen and (min-width: $above-tablet-length) {
            margin-top: 14px;
        }
    }

    &__privacy-bloc {
        margin-top: 32px;
        @media screen and (min-width: $above-tablet-length) {
            flex-direction: row;
            display: flex;
            justify-content: space-between;
            margin-top: 10px;
        }

        &__rigth-side {
            display: flex;
            flex-direction: column;
            @media screen and (min-width: $above-tablet-length) {
                flex-direction: row;
            }
        }

    }

    &__bloc-media {
        margin-top: 32px;
        display: flex;
        flex-direction: row-reverse;
        justify-content: center;

        &__round {
            width: 32px;
            height: 32px;
            border-radius: 24px;
            background-color: $forest;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 4px;
            cursor: pointer;
        }

        &__img {
            width: 12px;
            object-fit: contain;
        }
    }

    &__bloc-logo {
        margin-top: 48px;

        &__img {
            width: 100%;
            max-width: 170px;
            object-fit: contain;
            margin: 0 16px;
        }
    }

    &__bloc-fox {
        margin-top: 24px;

        &__text {
            font-size: 14px;
            line-height: 1.29;
        }
    }
}

.desktop-no-mt {
    @media screen and (min-width: $above-tablet-length) {
        margin-top: 0;
    }
}


</style>
